export enum EKYCTypes {
    UPDATE_USER_INFO_START = '[kyc] update user info start',
    UPDATE_USER_INFO_SUCCESS = '[kyc] update user info success',
    UPDATE_USER_INFO_FAILED = '[kyc] update user info failed',
}
